export { default } from './PartnerSignUp';
